/// <reference path='../../../../../common/types/window-config.d.ts' />
import * as React from 'react';
import { useEffect } from 'react';
import { AuthService } from '@enginuity-common/services/authService';
import { Spinner } from '@enginuity-apps-ui-components/atoms';

export default function Init() {
  const authService = new AuthService({
    baseUrl: window.spConfig.authBaseUrl,
    clientId: window.spConfig.authClientId
  });

  useEffect(() => {
    authService.signIn(false, 'groups');
  }, [authService]);

  return <div><Spinner active={true} /></div>;
}
